import Vue from 'vue'
import Router from 'vue-router'
import Portada from '../components/Portada'
import Kits from '../components/Kits'
import KitCita from '../components/KitCita'
import Ingreso from '../components/Ingreso'
import Consulta from '../components/Consulta'
import Turnos from '../components/Turnos'
import Teyuna from '../components/Teyuna'
import Reservacion from '../components/Reservacion'
import ReservacionCuota from '../components/ReservacionCuota'
import Cuotas from '../components/Cuotas'
import NuevoMedios from '../components/NuevoMedios'
import ReservacionNuevo from '../components/ReservacionTurnoMedio'

Vue.use(Router)

export const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: Portada,
      name: 'portada'
    },
    {
      path: '/ingreso',
      component: Ingreso,
      name: 'ingreso'
    },
    {
      path: '/kits',
      component: Kits,
      name: 'kits'
    },
    {
      path: '/kit/cita',
      component: KitCita,
      name: 'cita_kit'
    },
    {
      path: '/consulta',
      component: Consulta,
      name: 'consulta'
    },
    {
      path: '/citas',
      component: Turnos,
      name: 'turnos'
    },
    {
      path: '/teyuna',
      component: Teyuna,
      name: 'teyuna'
    },
    {
      path: '/reservacion/teyuna',
      component: Reservacion,
      name: 'reservacion_teyuna'
    },
    {
      path: '/cuotas',
      component: Cuotas,
      name: 'cuotas'
    },
    {
      path: '/reservacion/cuota',
      component: ReservacionCuota,
      name: 'reservacion_cuota'
    },
    {
      path: '/reservacion/medio',
      component: ReservacionNuevo,
      name: 'reservacion_medio'
    },
    {
      path: '/turno/medio',
      component: NuevoMedios,
      name: 'nuevo_medio'
    },
  ]
});




// WEBPACK FOOTER //
// ./src/router/index.js